module.exports = __webpack_public_path__ + "media/img/help_center/Institution_User_Settings_02-a9d1bec2aafe792f7386f82d60f83884.jpg";